import { motion } from 'framer-motion';
import React from 'react';

interface MotionWrapperProps {
  children: React.ReactNode;
  delay?: number;
}

export const MotionWrapper: React.FC<MotionWrapperProps> = ({ children, delay = 0 }) => {
  return (
    <motion.div
      animate={{ opacity: 1, y: 0 }}
      initial={{ opacity: 0, y: 30 }}
      transition={{ delay, duration: 0.2, ease: 'easeOut' }}
      whileHover={{ y: -8 }}
    >
      {children}
    </motion.div>
  );
};
